// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-table {
  font-family: "Bosch Sans", sans-serif !important;
}

.status-forecast-text {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  height: 100%;
}

.requestContainer {
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
}

.numberRequest {
  margin-left: 3px;
  font-weight: 500 !important;
  font-size: 17px;
}

.requestContainer span {
  font-size: 17px;
  font-weight: 700;
}

.pageSizeSelector {
  min-width: 180px;
  flex-shrink: 0;
}

.MuiDataGrid-root {
  font-family: "Bosch Sans", sans-serif !important;
}

.alignButtonGrid {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
}

.paginationRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.css-1v70q85-MuiDataGrid-root .MuiDataGrid-columnSeparator {
  color: transparent !important;
}

.css-1v70q85-MuiDataGrid-root .MuiDataGrid-columnHeaderDraggableContainer,
.css-1v70q85-MuiDataGrid-root.MuiDataGrid-root--noToolbar
  [aria-rowindex="1"]
  .MuiDataGrid-columnHeader--last {
  background-color: transparent;
}

.buttonImg {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 10px;
  width: 50px;
  height: 50px;
  justify-content: center;
  background-color: #007bc0;
}

.buttonActions {
  margin-right: 4px;
}

.buttonImg:disabled {
  background-color: #979ea4 !important;
  cursor: not-allowed;
}

.buttonImg:hover {
  background-color: #00629a;
}

.partNumberColluns {
  display: flex;
  padding-left: 20px;
  font-size: 14px;
}

.status-forecast {
  width: 22px;
  height: 22px;
  font-size: 1px;
  border-radius: 35px;
}

.novo {
  background-color: rgb(151, 158, 164);
}

.em_classificacao {
  background-color: rgb(157, 201, 255);
}

.reclassificar {
  background-color: #9e2896;
}

.pendente_validacao_fiscal {
  background-color: #a1dfdb;
}

.em_analise {
  background-color: rgb(238, 193, 0);
}

.finalizado {
  background-color: rgb(0, 136, 74);
}

.reclassificado {
  background-color: rgb(255, 157, 157);
}

.suspenso {
  background-color: rgb(232, 182, 227);
}

.pendente_grupo {
  background-color: #f97316;
}

.entregue_sap {
  background-color: #003e64;
}

.MuiDataGrid-cell {
  white-space: normal !important;
  line-height: 2 !important;
}

.descriptionText {
  display: flex;
  font-size: 14px;
  line-height: 1.2;
  height: 100%;
  align-items: center;
}

.css-1k1sjka-MuiDataGrid-main {
  border: 1px solid #c1c7cc;
}

.css-1v70q85-MuiDataGrid-root .MuiDataGrid-cell--textCenter {
  display: flex !important;
  align-items: center;
  text-align: left !important;
}

.css-wop1k0-MuiDataGrid-footerContainer {
  display: flex;
}

.css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root {
  visibility: initial !important;
}

.css-1hy1ks8-MuiDataGrid-root
  .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted)
  .MuiDataGrid-sortIcon {
  opacity: 1 !important;
}

.MuiDataGrid-root div div div div > .MuiDataGrid-cell {
  display: flex !important;
  align-items: center !important;
}

.MuiDataGrid-columnSeparator--resizable {
  pointer-events: none;
}

@media (max-width: 1390px) {
  .buttonImg {
    width: 40px;
    height: 40px;
    /* font-size: 14px; */
  }
}

@media (max-width: 768px) {
  .alignButtonGrid {
    flex-wrap: wrap;
    gap: 8px;
  }

  .pageSizeSelector {
    min-width: 150px;
  }
}

@media (max-width: 768px) {
  .MuiDataGrid-root .MuiDataGrid-footerContainer {
    height: auto !important;
    min-height: 145px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/grid/grid.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF","sourcesContent":[".title-table {\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n.status-forecast-text {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  height: 100%;\n}\n\n.requestContainer {\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: row;\n}\n\n.numberRequest {\n  margin-left: 3px;\n  font-weight: 500 !important;\n  font-size: 17px;\n}\n\n.requestContainer span {\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.pageSizeSelector {\n  min-width: 180px;\n  flex-shrink: 0;\n}\n\n.MuiDataGrid-root {\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n.alignButtonGrid {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  flex-direction: row;\n}\n\n.paginationRight {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-left: auto;\n}\n\n.css-1v70q85-MuiDataGrid-root .MuiDataGrid-columnSeparator {\n  color: transparent !important;\n}\n\n.css-1v70q85-MuiDataGrid-root .MuiDataGrid-columnHeaderDraggableContainer,\n.css-1v70q85-MuiDataGrid-root.MuiDataGrid-root--noToolbar\n  [aria-rowindex=\"1\"]\n  .MuiDataGrid-columnHeader--last {\n  background-color: transparent;\n}\n\n.buttonImg {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding-left: 10px;\n  width: 50px;\n  height: 50px;\n  justify-content: center;\n  background-color: #007bc0;\n}\n\n.buttonActions {\n  margin-right: 4px;\n}\n\n.buttonImg:disabled {\n  background-color: #979ea4 !important;\n  cursor: not-allowed;\n}\n\n.buttonImg:hover {\n  background-color: #00629a;\n}\n\n.partNumberColluns {\n  display: flex;\n  padding-left: 20px;\n  font-size: 14px;\n}\n\n.status-forecast {\n  width: 22px;\n  height: 22px;\n  font-size: 1px;\n  border-radius: 35px;\n}\n\n.novo {\n  background-color: rgb(151, 158, 164);\n}\n\n.em_classificacao {\n  background-color: rgb(157, 201, 255);\n}\n\n.reclassificar {\n  background-color: #9e2896;\n}\n\n.pendente_validacao_fiscal {\n  background-color: #a1dfdb;\n}\n\n.em_analise {\n  background-color: rgb(238, 193, 0);\n}\n\n.finalizado {\n  background-color: rgb(0, 136, 74);\n}\n\n.reclassificado {\n  background-color: rgb(255, 157, 157);\n}\n\n.suspenso {\n  background-color: rgb(232, 182, 227);\n}\n\n.pendente_grupo {\n  background-color: #f97316;\n}\n\n.entregue_sap {\n  background-color: #003e64;\n}\n\n.MuiDataGrid-cell {\n  white-space: normal !important;\n  line-height: 2 !important;\n}\n\n.descriptionText {\n  display: flex;\n  font-size: 14px;\n  line-height: 1.2;\n  height: 100%;\n  align-items: center;\n}\n\n.css-1k1sjka-MuiDataGrid-main {\n  border: 1px solid #c1c7cc;\n}\n\n.css-1v70q85-MuiDataGrid-root .MuiDataGrid-cell--textCenter {\n  display: flex !important;\n  align-items: center;\n  text-align: left !important;\n}\n\n.css-wop1k0-MuiDataGrid-footerContainer {\n  display: flex;\n}\n\n.css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root {\n  visibility: initial !important;\n}\n\n.css-1hy1ks8-MuiDataGrid-root\n  .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted)\n  .MuiDataGrid-sortIcon {\n  opacity: 1 !important;\n}\n\n.MuiDataGrid-root div div div div > .MuiDataGrid-cell {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.MuiDataGrid-columnSeparator--resizable {\n  pointer-events: none;\n}\n\n@media (max-width: 1390px) {\n  .buttonImg {\n    width: 40px;\n    height: 40px;\n    /* font-size: 14px; */\n  }\n}\n\n@media (max-width: 768px) {\n  .alignButtonGrid {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .pageSizeSelector {\n    min-width: 150px;\n  }\n}\n\n@media (max-width: 768px) {\n  .MuiDataGrid-root .MuiDataGrid-footerContainer {\n    height: auto !important;\n    min-height: 145px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
